import { CheckCircle } from "lucide-react";

const PurchaseSuccessPhase2 = () => {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="max-w-2xl w-full bg-black/40 backdrop-blur-md rounded-lg p-8 flex flex-col items-center text-center">
        <CheckCircle className="h-20 w-20 text-[#FF3366] mb-6" />
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Thanks for joining Gridbot & DeFi Mastery Phase 1 and Phase 2! You're amazing...
        </h1>
        <p className="text-xl text-gray-300 mb-4">
          Look out for a welcome email with <strong>"Gridbot & DeFi Course Login"</strong> as subject line.
        </p>
        <p className="text-gray-400">
          Please check your inbox (and spam folder) for your course access details covering both phases.
        </p>
      </div>
    </div>
  );
};

export default PurchaseSuccessPhase2;